import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './AssetSummaryByClass.scss';
import {
  injectIntl,
  FormattedMessage,
  FormattedNumber,
  intlShape
} from 'react-intl';

export class AssetSummaryByClass extends Component {
  render() {
    const summary = [
      'total',
      'active',
      'expiring_7_days',
      'expiring_30_days',
      'expired'
    ].map(key => {
      const value = (this.props.summary && this.props.summary[key]) || 0;
      return {
        key,
        value
      };
    });

    return (
      <div className="asset-class-summary">
        {summary.map(entry => (
          <div key={entry.key} className="summary-item">
            <div className="summary-item-header">
              <FormattedMessage
                id={`components.ecs.distribution.${entry.key}`}
              />
            </div>
            <div className="summary-item-value">
              <FormattedNumber value={entry.value || 0} />
            </div>
          </div>
        ))}
      </div>
    );
  }
}

AssetSummaryByClass.propTypes = {
  summary: PropTypes.object,
  location: PropTypes.object,
  intl: intlShape.isRequired
};

export default injectIntl(AssetSummaryByClass);
